import {UserAction, ActionType} from '../bean/UserAction';
export default {
    beforeRouteEnter (to, from, next) {
        if(to.name.lastIndexOf('editor') > -1){
            // 编辑页面，此函数无法获取模板id,直接在具体页面实现
            next();
           return;
        }
        if(!to.meta.userActionKey){ //无需记录
            next();
            return;
        }
        let lastTime = sessionStorage.getItem(to.path);
        let startTime = moment(new Date).format('YYYY-MM-DD HH:mm:ss');
        if(!lastTime) {
            lastTime = startTime;
            sessionStorage.setItem(to.path, lastTime);
        }
        next(
            vm => {
            let endTime = null;
            let pageKey = to.meta.userActionKey;
            let projectId = vm.$store.state.app.projectId;
            let userId = vm.$store.state.app.loginUser.id;
            let userAction = new UserAction(
                projectId,
                startTime,
                endTime,
                pageKey,
                ActionType.page.enter.key,
                userId ? userId : 0,
            );
            if(projectId){
                vm.webWorker.postMessage(userAction);
            }
           }
        );
    },
    beforeRouteLeave (to, from, next) {
        if(from.name.lastIndexOf('editor') > -1){
            // 编辑页面，此函数无法获取模板id,直接在具体页面实现
            next();
            return;
        }
        if(!from.meta.userActionKey){ //无需记录
            next();
            return;
        }
        let enterTime = sessionStorage.getItem(from.path);
        let endTime = moment(new Date).format('YYYY-MM-DD HH:mm:ss');
        sessionStorage.setItem(from.path, '');
        let pageKey = `${from.meta.userActionKey}`;
        let projectId = this.$store.state.app.projectId;
        let userId = this.$store.state.app.loginUser.id;
        let userAction = new UserAction(
            projectId,
            enterTime,
            endTime,
            pageKey,
            ActionType.page.leave.key,
            userId ? userId : 0,
        );
        this.webWorker.postMessage(userAction);
        next();
    },
}